export const SUPPORTED_LANGUAGES = ['es', 'en', 'fr'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

